import { render, staticRenderFns } from "./TwoColumnsTable.vue?vue&type=template&id=3892ef94&scoped=true"
import script from "./TwoColumnsTable.vue?vue&type=script&lang=js"
export * from "./TwoColumnsTable.vue?vue&type=script&lang=js"
import style0 from "./TwoColumnsTable.vue?vue&type=style&index=0&id=3892ef94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3892ef94",
  null
  
)

export default component.exports